import _ from "lodash";

import React from "react";
import classes from "./DialogueBoxV3.scss";
import PropTypes from "prop-types";
import { FormTextInput } from "UIComponents/InputTextField";
import { FormTextAreaInput } from "UIComponents/TextAreaInput";
import { isURL } from "Utils";
import { Button, Modal } from "@toddle-edu/ds-web";
import { InformationFilled } from "@toddle-edu/ds-icons";
import { isPortfolioParityEnabled } from "Post/utils";

const BLANK_STRING = "";
class DialogueBoxV3 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      promptText: _.get(props, "promptDetail.promptText", ""),
    };

    if (props.updateRef) {
      props.updateRef(this);
    }
  }

  onPromptTextChange = params => {
    this.setState({ promptText: params.promptText });
  };
  onClickContainer = event => {
    event.stopPropagation();
    event.preventDefault();
  };
  onClickButton2 = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (this.props.onClickButton2) {
      if (this.promptTextRef) {
        if (this.props.promptDetail.checkValidation) {
          const errorCount = this.promptTextRef.isValid();

          if (errorCount > 0) {
            return;
          }
        }
        this.props.onClickButton2(this.state.promptText);
      } else {
        this.props.onClickButton2();
      }
    }
    if (this.props.shouldCloseOnButtonClick) {
      this.props.toggleDialogueBoxDisplay();
    }
  };

  onClickButton1 = event => {
    event.stopPropagation();
    event.preventDefault();
    if (this.props.onClickButton1) {
      this.props.onClickButton1();
    }
    this.props.toggleDialogueBoxDisplay();
  };

  onPromptEnter = () => {
    this.onClickButton2();
  };

  onCancelClick = e => {
    e && e.stopPropagation();
    if (this.props.toggleDialogueBoxDisplay) {
      this.props.toggleDialogueBoxDisplay({ isCancel: true });
    }
  };

  customValidation = value => {
    const {
      promptDetail: { customValidationType },
    } = this.props;
    switch (customValidationType) {
      case "URL":
        if (isURL(value)) return "";
        else return "Please enter valid url";
      // break;
      default:
        return "";
      // break;
    }
  };

  render() {
    const {
      promptDetail: { customValidationType },
      promptBoxType,
      modalBodyStyle,
      button1Styles,
      button2Styles,
      button1Props,
      button2Props,
      warningTextStyles,
      modalTitle,
      modalTitleSubText,
      textAreaRows,
      showWarningOnTop,
      showWarningOnBottom,
      customComponent,
      width = "440px",
      height = "fit-content",
      showAlert = false,
      showLabel = true,
    } = this.props;

    return (
      <Modal
        dsVersion={isPortfolioParityEnabled() ? "2.0" : "1.0"}
        hasOverlay={true}
        isOpen={true}
        onClose={this.onCancelClick}
        shouldCloseOnEsc={true}
        width={width}
        height={height}
      >
        <React.Fragment>
          <Modal.Header
            title={modalTitle}
            subtitle={!showAlert ? modalTitleSubText : ""}
          />
          <Modal.Body className={classes.modalBody} style={modalBodyStyle}>
            {showAlert ? (
              <div className={classes.alert}>
                <InformationFilled variant={"link"} />
                {modalTitleSubText}
              </div>
            ) : null}
            {this.props.warningText &&
              showWarningOnTop &&
              !showWarningOnBottom && (
                <div
                  className={classes.warningTextTop}
                  style={warningTextStyles}
                >
                  {this.props.warningText}
                </div>
              )}
            {this.props.isPromptBox ? (
              promptBoxType == "InputTextField" ? (
                <FormTextInput
                  name="promptText"
                  placeholder={this.props.promptDetail.placeholder}
                  label={
                    showLabel ? this.props.promptDetail.label : BLANK_STRING
                  }
                  updateInputField={this.onPromptTextChange}
                  value={this.state.promptText}
                  ref={ref => (this.promptTextRef = ref)}
                  onEnter={this.onPromptEnter}
                  autoFocus={true}
                  customValidation={
                    customValidationType && this.customValidation
                  }
                />
              ) : (
                <FormTextAreaInput
                  name="promptText"
                  minRows={textAreaRows}
                  maxRows={textAreaRows}
                  placeholder={this.props.promptDetail.placeholder}
                  label={
                    showLabel ? this.props.promptDetail.label : BLANK_STRING
                  }
                  updateInputField={this.onPromptTextChange}
                  ref={ref => (this.promptTextRef = ref)}
                  value={this.state.promptText}
                  autoFocus={true}
                  onEnter={this.onPromptEnter}
                  customValidation={
                    customValidationType && this.customValidation
                  }
                />
              )
            ) : (
              <React.Fragment>
                {this.props.modalBody}
                {this.props.warningText &&
                  showWarningOnBottom &&
                  !showWarningOnTop && (
                    <div
                      className={classes.warningTextBottom}
                      style={warningTextStyles}
                    >
                      {this.props.warningText}
                    </div>
                  )}
              </React.Fragment>
            )}
            {customComponent && customComponent()}
          </Modal.Body>

          <Modal.Footer>
            <div
              className={classes.modalFooter}
              style={this.props.footerContainerStyle}
            >
              {!!this.props.button1 && (
                <div className={classes.button1Div} style={button1Styles}>
                  <Button
                    dsVersion={isPortfolioParityEnabled() ? "2.0" : "1.0"}
                    onClick={this.onClickButton1}
                    {...button1Props}
                  >
                    {this.props.button1}
                  </Button>
                </div>
              )}
              {!!this.props.button2 && (
                <div className={classes.button2Div} style={button2Styles}>
                  <Button
                    dsVersion={isPortfolioParityEnabled() ? "2.0" : "1.0"}
                    onClick={this.onClickButton2}
                    {...button2Props}
                  >
                    {this.props.button2}
                  </Button>
                </div>
              )}
            </div>
          </Modal.Footer>
        </React.Fragment>
      </Modal>
    );
  }
}

DialogueBoxV3.propTypes = {
  size: PropTypes.string,
  modalTitle: PropTypes.string,
  modalTitleSubText: PropTypes.string,
  modalBody: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  button1: PropTypes.string,
  button2: PropTypes.string,
  toggleDialogueBoxDisplay: PropTypes.func,
  onClickButton2: PropTypes.func,
  onClickButton1: PropTypes.func,
  isPromptBox: PropTypes.bool,
  promptBoxType: PropTypes.string,
  promptDetail: PropTypes.any,
  modalBodyStyle: PropTypes.object,
  button1Props: PropTypes.object,
  button2Props: PropTypes.object,
  warningTextStyles: PropTypes.object,
  modalTitleSubTextStyles: PropTypes.object,
  cancelButtonStyle: PropTypes.object,
  textAreaRows: PropTypes.number,
  closeButtonSize: PropTypes.string,
  customComponent: PropTypes.func,
  shouldCloseOnButtonClick: PropTypes.bool,
};

DialogueBoxV3.defaultProps = {
  isPromptBox: false,
  promptBoxType: "InputTextField",
  warningText: "",
  modalTitleSubText: "",
  footerContainerStyle: {},
  promptDetail: {
    label: "",
    placeholder: "",
    checkValidation: false,
    promptText: "",
  },
  modalBodyStyle: {},
  button1Props: {},
  button2Props: {},
  button1Styles: {},
  button2Styles: {},
  headerStyles: {},
  showCloseButton: true,
  warningTextStyles: {},
  headerTitleStyles: {},
  modalTitleSubTextStyles: {
    color: "#717171",
    fontSize: "1.4rem",
    marginTop: "6px",
    fontWeight: "500",
  },
  cancelButtonStyle: {},
  textAreaRows: 3,
  closeButtonSize: "large",
  showWarningOnTop: false,
  showWarningOnBottom: false,
  shouldCloseOnButtonClick: true,
};

export default DialogueBoxV3;
